import { createLogger } from "./logging.ts";
import { captureErrorWithPayload } from "./error.ts";
import { createDefaultOptions } from "./ky.ts";
import ky from "@otto-ec/global-resources/ky";

const APM_ERROR_KEYS = {
	tag: "ft9-benefit-detailview-activation-failed",
	sheet: "ft9-benefit-sheet-activation-failed",
};

export enum ActivationResponseType {
	Activated = 0,
	Conflict = 1,
	Error = 2,
}

export class ActivationClient {
	async activateByUrl(activationUrl: string, errorLoggingPayload: object, namespace: "tag" | "sheet"): Promise<ActivationResponseType> {
		const log = createLogger(namespace, "activation-client");
		const apmErrorKey = APM_ERROR_KEYS[namespace];
		const apmErrorLabels = { service: namespace, module: "activation-client", team: "ft9" };
		const fetchOptions: RequestInit = {
			method: "POST",
			headers: { "X-Requested-With": "XMLHttpRequest" },
		};

		log.info(`Call ${activationUrl} to activate benefit using following options: ${JSON.stringify(fetchOptions)}`);

		try {
			const options = {
				timeout: 1000,
				throwHttpErrors: false,
				...fetchOptions,
				...createDefaultOptions(log, activationUrl),
			};
			const response = await ky(activationUrl, options);

			if (!response.ok) {
				const custom = {
					...errorLoggingPayload,
					status_code: response.status,
					response_type: response.type,
					response_ok: response.ok,
					response_headers: JSON.stringify(response.headers),
				};
				captureErrorWithPayload({ message: "Response is not OK", type: apmErrorKey, labels: apmErrorLabels, custom, payload: response?.status });
			}

			if (response.status === 200) {
				return ActivationResponseType.Activated;
			}
			if (response.status === 409) {
				return ActivationResponseType.Conflict;
			}

			return ActivationResponseType.Error;
		} catch (e: unknown) {
			const custom = {
				...errorLoggingPayload,
				failing_reason: "error",
			};
			captureErrorWithPayload({ message: "Activation failed", type: apmErrorKey, labels: apmErrorLabels, custom, payload: e });

			return ActivationResponseType.Error;
		}
	}
}
